import { request } from "@/utils/request";

let user = {
  login: (u, p) => {
    return request("post", "/admin/login", { username: u, password: p });
  },
  changePassword: (old, newP) => {
    return request("post", "/admin/user/resetPassword", {
      oldPassword: old,
      newPassword: newP
    });
  }
};

let defaultPageSize = 15;

let member = {
  get: param => {
    param["pageSize"] = defaultPageSize;
    return request("get", "/admin/member/list", param);
  }
};

let product = {
  get: param => {
    param["pageSize"] = defaultPageSize;
    return request("get", "/admin/product/list", param);
  },
  create: param => {
    return request("post", "/admin/product/create", param);
  },
  update: param => {
    return request("post", "/admin/product/update", param);
  },
  verifyPass: id => {
    return request("post", "/admin/product/verify_pass", {
      id: id
    });
  },
  verifyReject: id => {
    return request("post", "/admin/product/verify_reject", {
      id: id
    });
  },
  publish: id => {
    return request("post", "/admin/product/publish", {
      id: id
    });
  },
  unpublish: id => {
    return request("post", "/admin/product/unpublish", {
      id: id
    });
  },
  delete: id => {
    return request("post", "/admin/product/delete", {
      id: id
    });
  }
};

let promote = {
  getList: param => {
    param["pageSize"] = defaultPageSize;
    return request("get", "/admin/promotion/list", param);
  },
  getDetail: id => {
    return request("get", "/admin/promotion/detail", { promotionId: id });
  },
  create: param => {
    return request("post", "/admin/promotion/create", param);
  },
  update: param => {
    return request("post", "/admin/promotion/update", param);
  },
  verifyPass: id => {
    return request("post", "/admin/promotion/verify_pass", {
      id: id
    });
  },
  verifyReject: id => {
    return request("post", "/admin/promotion/verify_reject", {
      id: id
    });
  },
  stop: id => {
    return request("post", "/admin/promotion/stop", {
      id: id
    });
  },
  resume: id => {
    return request("post", "/admin/promotion/resume", {
      id: id
    });
  },
  delete: id => {
    return request("post", "/admin/promotion/delete", {
      id: id
    });
  }
};

let account = {
  getList: param => {
    return request("get", "/admin/adminuser/list", param);
  },
  getDetail: id => {
    return request("get", `/admin/adminuser/detail?id=${id}`);
  },
  create: param => {
    return request("post", "/admin/adminuser/create", param);
  },
  update: param => {
    return request("post", "/admin/adminuser/update", param);
  },
  ban: id => {
    return request("post", "/admin/adminuser/ban", {
      id: id
    });
  },
  unban: id => {
    return request("post", "/admin/adminuser/unban", {
      id: id
    });
  },
  delete: id => {
    return request("post", "/admin/adminuser/delete", {
      id: id
    });
  }
};

let order = {
  getList: param => {
    param["pageSize"] = defaultPageSize;
    return request("get", "/admin/order/list", param);
  },
  getDetail: id => {
    return request("get", `/admin/order/detail?id=${id}`);
  }
};

let refund = {
  getList: param => {
    param["pageSize"] = defaultPageSize;
    return request("get", "/admin/order/refund/list", param);
  },
  getDetail: id => {
    return request("get", `/admin/order/refund/detail?id=${id}`);
  }
};

let promotePeople = {
  get: param => {
    param["pageSize"] = defaultPageSize;
    return request("get", "/admin/member/businessman/list", param);
  },
  getAchevement: id => {
    return request("get", `/admin/member/businessman/myachievement?id=${id}`);
  },
  create: param => {
    return request("post", "/admin/member/businessman/create", param);
  },
  delete: id => {
    return request("post", "/admin/member/businessman/delete", {
      id: id
    });
  },
  ban: id => {
    return request("post", "/admin/member/businessman/ban", {
      id: id
    });
  },
  unban: id => {
    return request("post", "/admin/member/businessman/unban", {
      id: id
    });
  }
};

let banner = {
  get: () => {
    return request("get", "/admin/banner/list");
  },
  create: param => {
    return request("post", "/admin/banner/create", param);
  },
  update: param => {
    return request("post", "/admin/banner/update", param);
  },
  delete: id => {
    return request("post", `/admin/banner/delete/${id}`);
  }
};

let h5Api = {
  index: () => {
    return request("get", "/api/homepage");
  },
  myPoster: () => {
    return request("get", "/api/user/mypost");
  },
  myAchievement: number => {
    return request("get", `/api/user/myachievement?serialNumber=${number}`);
  },
  login: number => {
    return request("get", `/api/user/checkBankCode?bankCode=${number}`);
  },
  bindNumber: (phone, number) => {
    return request("post", `/api/user/bindSerialNumber`, {
      phone: phone,
      serialNumber: number
    });
  }
};

let website = {
  topNav: {
    getList: () => {
      return request("get", "/navigations");
    }
  },
  bottomNav: {
    getQrcode: () => {
      return request("get", "/bottom-navs");
    }
  },
  aboutUs: {
    getData: () => {
      return request("get", "/About-pages");
    }
  },
  news: {
    getList: () => {
      return request("get", "/news-pages");
    }
  },
  products: {
    getList: () => {
      return request("get", "/product-pages");
    }
  },
  index: {
    getData: () => {
      return request("get", "/Index-pages");
    }
  },
  introduction: {
    getData: () => {
      return request("get", "/introductions");
    }
  },
  allCultures: {
    getData: () => {
      return request("get", "/all-cultures");
    }
  },
  allNews: {
    getData: () => {
      return request("get", "/all-news");
    }
  },
  allJobs: {
    getData: () => {
      return request("get", "/all-jobs");
    }
  },
  allProducts: {
    getData: () => {
      return request("get", "/all-products");
    }
  },
  allContacts: {
    getData: () => {
      return request("get", "/all-contacts");
    }
  },
  allMessages: {
    submit: params => {
      return request("post", "/all-messages", params);
    }
  }
};

let category = {};

export {
  website,
  h5Api,
  category,
  user,
  account,
  member,
  product,
  promote,
  order,
  refund,
  promotePeople,
  banner
};



// WEBPACK FOOTER //
// ./src/api/page-api.js